"use strict";
// tslint:disable:deprecation
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
// If you have any questions about this file, message #dev-shared-widgets
var SpacingUnit = 6;
var SizingUnit = SpacingUnit;
// order matters
var graysPreset = [
    '#000000', '#1B1B1B', '#333333', '#555555', '#666666', '#898989',
    '#FFFFFF', '#F5F5F5', '#E6E6E6', '#D4D4D4', '#C0C0C0', '#B4B4B4'
];
// order matters
var darkPreset = [
    '#F28E2B', '#F9A655', '#FFBE7D', '#B07AA1', '#C290B4', '#D4A6C8',
    '#B6992D', '#D3B348', '#F1CE63', '#D37295', '#E799B3', '#FABFD2',
    '#59A14F', '#72B966', '#8CD17D', '#E15759', '#F17B79', '#FF9D9A',
    '#499894', '#69AAA5', '#86BCB6', '#9D7660', '#BA9582', '#D7B5A6',
    '#4E79A7', '#75A1C7', '#A0CBE8', '#79706E', '#998F8C', '#BAB0AC',
    '#606B76', '#818B91', '#A7ACAD', '#76B7B2', '#FF9DA7', '#EDC948'
];
// order matters
var lightPreset = [
    '#EFEBE8', '#F5F1F0', '#F9F8F7', '#F0EAE8', '#F5F0EF', '#FAF5F4',
    '#F5EDDC', '#FAF4E7', '#FEFAF1', '#E9EBE0', '#F0F1E8', '#F7F7F0',
    '#EBEBEB', '#F2F2F2', '#F9F9F9', '#DFE7E8', '#E9F0F1', '#F2F9F9',
    '#F3EBF3', '#F7F1F6', '#FBF7FB', '#E2E6F0', '#E9EDF5', '#F0F3FA',
    '#E6ECF0', '#EEF1F3', '#F2F6F7', '#DDEBF0', '#E7F1F5', '#F0F7FA',
    '#DFEDEB', '#E9F3F2', '#F3FAF9', '#E8EDDA', '#EFF3E3', '#F7FAF0',
    '#F5EAD7', '#F6EEE3', '#FAF5F0', '#F9E9E0', '#F9EEE8', '#F9F3EF'
];
// order matters
var maestroFlowPreset = [
    '#4F6980', '#3D7FA6', '#8BC2CA', '#499893',
    '#62AEA1', '#7DC4AE', '#638B66', '#86AF6A',
    '#C3BB3D', '#EFC637', '#F6A035', '#F37941',
    '#F59A9A', '#CD677F', '#C497B7', '#845578',
    '#B9AA98', '#7E756D', '#9EB0A5', '#B56252'
];
// TODO: Semantic names - https://mytableau.tableaucorp.com/display/devft/Browser+Font+Reconciliation
var FontSizes = {
    XXLarge: 24,
    XLarge: 18,
    Large: 13,
    Default: 12,
    Small: 11,
    Tiny: 10
};
var FontColors = {
    PrimaryDark: 'rgba(0, 0, 0, 0.9)',
    Primary: 'rgba(0, 0, 0, 0.8)',
    PrimaryMedium: 'rgba(0, 0, 0, 0.7)',
    PrimaryLight: 'rgba(0, 0, 0, 0.6)',
    Secondary: 'rgba(0, 0, 0, 0.56)',
    Disabled: 'rgba(0, 0, 0, 0.35)',
    InvertedPrimary: 'rgb(255, 255, 255)',
    InvertedSecondary: 'rgba(255, 255, 255, 0.56)',
    InvertedDisabled: 'rgba(255, 255, 255, 0.35)',
};
var GreyColors = {
    Grey250: 'rgb(250, 250, 250)',
    Grey245: 'rgb(245, 245, 245)',
    Grey235: 'rgb(235, 235, 235)',
    Grey230: 'rgb(230, 230, 230)',
    Grey225: 'rgb(225, 225, 225)',
    Grey212: 'rgb(212, 212, 212)',
    Grey203: 'rgb(203, 203, 203)',
    Grey180: 'rgb(180, 180, 180)',
    Grey180Disabled: 'rgba(180, 180, 180, 0.35)',
    Grey102: 'rgb(102, 102, 102)',
    Grey51: 'rgb(51, 51, 51)',
    Grey51Disabled: 'rgba(51, 51, 51, 0.2)',
};
var SemanticColors = {
    White: 'rgb(255, 255, 255)',
    WhiteTransparent: 'rgba(255, 255, 255, 0.25)',
    WhiteDisabled: 'rgba(255, 255, 255, 0.35)',
    WhiteTransparentLine: 'rgba(255, 255, 255, 0.5)',
    WhiteTransparentLineHover: 'rgba(255, 255, 255, 0.8)',
    Black: 'rgb(0, 0, 0)',
    Transparent: 'rgba(0, 0, 0, 0)',
    ActionLight: 'rgb(235, 143, 80)',
    ActionDark: 'rgb(209, 107, 54)',
    AttentionLight: 'rgb(235, 68, 84)',
    AttentionDark: 'rgb(201, 58, 71)',
    AttentionDarkDisabled: 'rgba(201, 58, 71, 0.35)',
    Continuous: 'rgb(0, 177, 128)',
    ContinuousDark: 'rgb(0, 151, 104)',
    Discrete: 'rgb(73, 150, 178)',
    DiscreteDark: 'rgb(54, 126,156)',
    GoLight: 'rgb(45, 204, 151)',
    GoDark: 'rgb(47, 163, 125)',
    GoDarkDisabled: 'rgba(47, 163, 125, 0.35)',
    Shaded: 'rgba(0, 0, 0, 0.07)',
    ApplicationBlue: 'rgb(34, 38, 54)',
    DesktopBlue: 'rgb(53, 92, 128)',
    ServerBlue: 'rgb(42, 87, 117)',
    OnlineBlue: 'rgb(40, 94, 127)',
    OpaqueGlass: GreyColors.Grey245,
    Focus: 'rgb(52, 152, 219)',
    L1: GreyColors.Grey250,
    L2: GreyColors.Grey245,
    L2_5: GreyColors.Grey235,
    L3: GreyColors.Grey230,
    L4: GreyColors.Grey225,
    L5: GreyColors.Grey212,
    L6: GreyColors.Grey203,
    L7: GreyColors.Grey180,
    L8: GreyColors.Grey102,
    L9: GreyColors.Grey51,
    L9Disabled: GreyColors.Grey51Disabled,
    F1: GreyColors.Grey250,
    F2: GreyColors.Grey245,
    F2_5: GreyColors.Grey235,
    F3: GreyColors.Grey230,
    F4: GreyColors.Grey225,
    F5: GreyColors.Grey212,
    F6: GreyColors.Grey203,
    F7: GreyColors.Grey180,
    F7Disabled: GreyColors.Grey180Disabled,
    F8: GreyColors.Grey102,
    F9: GreyColors.Grey51
};
var TabStyles = {
    Colors: SemanticColors,
    Shadow: {
        Standard: '1px 1px 2px 0px rgba(0, 0, 0, 0.15)',
    },
    Spacing: {
        SmallSpace: SpacingUnit / 2,
        DefaultSpace: SpacingUnit,
        MediumSpace: SpacingUnit * 2,
        LargeSpace: SpacingUnit * 3,
        ExtraLargeSpace: SpacingUnit * 4,
    },
    Sizing: {
        BaseUnit: SizingUnit,
        RowHeight: 24,
        ButtonMinWidth: SizingUnit * 15,
        BorderWidth: 1,
        ButtonBorderWidth: 2,
        BorderRadius: 1,
        SelectionBorderWidth: SizingUnit / 2,
        ListRowHeight: 20
    },
    Typography: {
        FontFamily: 'inherit',
        Sizing: FontSizes,
        Color: FontColors
    },
    Opacity: {
        ClearGlass: 0.01,
        Disabled: 0.35,
        OpaqueGlass: 0.33,
    },
    ColorPickerPresets: {
        Dark: graysPreset.concat(darkPreset),
        Light: graysPreset.concat(lightPreset),
        MaestroFlowColors: maestroFlowPreset,
    }
};
exports.TabStyles = TabStyles;
/**
 * Have to override the object rather than just set TabStyles.
 */
var overrideTabStyles = function (overridingTabStyles) {
    TabStyles.Colors = tslib_1.__assign({}, TabStyles.Colors, overridingTabStyles.Colors);
    TabStyles.Opacity = tslib_1.__assign({}, TabStyles.Opacity, overridingTabStyles.Opacity);
    TabStyles.Shadow = tslib_1.__assign({}, TabStyles.Shadow, overridingTabStyles.Shadow);
    TabStyles.Sizing = tslib_1.__assign({}, TabStyles.Sizing, overridingTabStyles.Sizing);
    TabStyles.Spacing = tslib_1.__assign({}, TabStyles.Spacing, overridingTabStyles.Spacing);
    if (overridingTabStyles.Typography) {
        TabStyles.Typography.FontFamily = overridingTabStyles.Typography.FontFamily ?
            overridingTabStyles.Typography.FontFamily : TabStyles.Typography.FontFamily;
        TabStyles.Typography.Color = tslib_1.__assign({}, TabStyles.Typography.Color, overridingTabStyles.Typography.Color);
        TabStyles.Typography.Sizing = tslib_1.__assign({}, TabStyles.Typography.Sizing, overridingTabStyles.Typography.Sizing);
    }
};
exports.overrideTabStyles = overrideTabStyles;
//# sourceMappingURL=TabStyles.js.map